import { Helmet } from 'react-helmet-async';
import InfoTooltip from '../components/InfoTooltip';
import { useNavigate, useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { FaRegEye } from 'react-icons/fa';
import { CiTrash } from 'react-icons/ci';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
  Chip,
  TextField,
} from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// components
import Swal from 'sweetalert2';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import { createBnbList, deleteBNB, deleteUser, getBnbList, getUsers } from '../helper/backend_helper';
import appConfig from '../config';

// ----------------------------------------------------------------------
// const users = [
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
// ];

const TABLE_HEAD = [
  { id: 'BnBLongName', label: 'BnB Long Name', alignRight: false },
  { id: 'BnBShortName', label: 'BnB Short Name', alignRight: false },
  { id: '', label: 'Address', alignRight: false },
  { id: '', label: 'City', alignRight: false },
  { id: '', label: 'Postal Code', alignRight: false },
  { id: '', label: 'Latitude', alignRight: false },
  { id: '', label: 'Longitude', alignRight: false },
  { id: '', label: 'Wifi SSID', alignRight: false },
  { id: '', label: 'Wifi Password', alignRight: false },
  { id: '', label: 'Contact No', alignRight: false },
  { id: '', label: 'Status', alignRight: false },
  { id: '', label: 'Money Left', alignRight: false },
  { id: '', label: 'Cleaning Count', alignRight: false },
  // { id: '', label: 'CheckIn Status', alignRight: false },
  // { id: '', label: 'UnUsed', alignRight: false },
  { id: '', label: 'Google Maps Link', alignRight: false },
  { id: '', label: 'Youtube Link', alignRight: false },
  { id: '', label: 'Video Link', alignRight: false },
  { id: '', label: 'Actions', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user?.firstName?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1 ||
        _user?.lastName?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [clickedRowData, setClickedRowData] = useState(null);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [users, setUsers] = useState([]);
  console.log('users', users);
  const [searchText, setSearchText] = useState('');

  const handleSearchText = (event) => {
    setSearchText(event.target.value);
  };
  async function fetchData() {
    try {
      setLoading(true);
      const usersResponse = await getBnbList();
      setUsers(usersResponse?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const [loading, setLoading] = useState(false);

  const handleDelete = async (id) => {
    try {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to delete this BNB?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      });

      if (confirmed.isConfirmed) {
        const response = await deleteBNB(id);
        Swal.fire({
          icon: 'success',
          title: 'BNB deleted successfully',
        });
        fetchData();
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while deleting BNB',
      });
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  let filteredUsers = [];
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  // const encodedData = encodeURIComponent(JSON.stringify(clickedRow));

  const handleRefreshCities = async () => {
    try {
      setRefreshLoading(true);
      console.log('1');
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await createBnbList(Categoryheaders);
      console.log(response);
      fetchData();
      setRefreshLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setRefreshLoading(false);
    }
  };

  filteredUsers = users.sort((a, b) => {
    return a.BnBShortName.localeCompare(b.BnBShortName);
  });

  filteredUsers = users.filter((user) => {
    const lowerCaseSearch = searchText?.toLowerCase();
    const matchesBnBLongName = user?.BnBLongName?.toLowerCase()?.includes(lowerCaseSearch);
    const matchesBnbShortName = user?.BnBShortName?.toLowerCase()?.includes(lowerCaseSearch);
    const addresss = user?.address?.toLowerCase()?.includes(lowerCaseSearch);
    const city = user?.city?.toLowerCase()?.includes(lowerCaseSearch);
    const postalCodeMatches = user?.postalCode?.toString()?.includes(searchText);
    return matchesBnBLongName || matchesBnbShortName || addresss || city || postalCodeMatches;
  });
  return (
    <>
      <Helmet>
        <title> BnB Lists </title>
      </Helmet>

      <Card sx={{ p: 3 }}>
        <Stack mb={3} direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h4">
              BnB Lists{' '}
              <InfoTooltip
                width={20}
                title="The master list of every property (BnB) you manage, with its address, GPS coordinates, WiFi, contact number, status and useful links. Records are pulled in from your channel manager with Fetch BnB List and enriched here. Use the search to find a property and Edit or Delete to keep each listing accurate."
              />
            </Typography>
            <TextField
              onChange={handleSearchText}
              value={searchText}
              size="small"
              id="outlined-search"
              label="Search"
              type="search"
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            {/* <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
                width: 200,
              }}
              variant="contained"
              onClick={() => navigate('/bnbList/detail_bnbList')}
            >
            BnB Detail
            </Button> */}
            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
                width: 200,
              }}
              variant="contained"
              onClick={handleRefreshCities}
            >
              {refreshLoading ? <CircularProgress size={20} color="inherit" /> : 'Fetch BnB List'}
            </Button>
          </Stack>
        </Stack>

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={users.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    _id,
                    BnBLongName,
                    videoLink,
                    BnBShortName,
                    address,
                    city,
                    contactNumber,
                    googleMapLink,
                    latitude,
                    longitude,
                    postalCode,
                    wifiPassword,
                    wifiSSID,
                    utubeLink,
                    status,
                    cleaningCount,
                    isPaymentLeft,
                    // checkInStatus,
                    // unUsed
                  } = row;

                  return (
                    <TableRow hover key={_id}>
                      <TableCell component="th" scope="row">
                        {/* <Avatar alt={name} src={`${appConfig.FILe_URL}${directory}/${image}`} /> */}
                        {/* <Avatar alt={name} src={image} /> */}
                        <Typography align="center" variant="subtitle2" noWrap>
                          {BnBLongName}
                        </Typography>
                      </TableCell>

                      <TableCell align="center">{BnBShortName}</TableCell>
                      <TableCell align="center">{address}</TableCell>
                      <TableCell align="center">{city}</TableCell>
                      <TableCell align="center">{postalCode}</TableCell>
                      <TableCell align="center">{latitude}</TableCell>
                      <TableCell align="center">{longitude}</TableCell>
                      <TableCell align="center">{wifiSSID}</TableCell>
                      <TableCell align="center">{wifiPassword}</TableCell>
                      <TableCell sx={{ minWidth: 200 }} align="center">
                        {contactNumber}
                      </TableCell>

                      <TableCell align="center">{status.replace(/\b\w/g, (char) => char.toUpperCase())}</TableCell>
                      <TableCell align="center">{isPaymentLeft ? 'Yes' : 'No'}</TableCell>
                      <TableCell align="center">{cleaningCount}</TableCell>

                      <TableCell align="center">{googleMapLink}</TableCell>
                      <TableCell sx={{ cursor: 'pointer' }} align="center">
                        {
                          <a href={`${utubeLink}`} target="_blank" rel="noopener noreferrer">
                            {utubeLink}
                          </a>
                        }
                      </TableCell>
                      <TableCell align="center">
                        {videoLink === '' ? (
                          'Vidoe Not Uploaded'
                        ) : (
                          <a href={`${appConfig.FILE_URL}${videoLink}`} target="_blank" rel="noopener noreferrer">
                            {`${appConfig.FILE_URL}${videoLink}`}
                          </a>
                        )}
                      </TableCell>

                      {/* <TableCell align="left">
                          {
                            <Label color={(status && 'success') || 'error'}>
                              {sentenceCase(status ? 'Active' : 'Pending')}
                            </Label>
                          }
                        </TableCell> */}
                      {/* <TableCell align="left">
                          {
                            <Label style={{ width: 70 }} color={status === 'active' ? 'success' : 'error'}>
                              {sentenceCase(status === 'active' ? 'Active' : 'Pending')}
                            </Label>
                          }
                        </TableCell> */}

                      {/* <TableCell align="left">
                          <Label color={(status === 'banned' && 'error') || 'success'}>{sentenceCase(status)}</Label>
                        </TableCell> */}

                      <TableCell align="center">
                        <Stack
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 1,
                          }}
                        >
                          {/* <Button
                          onClick={() => navigate('/bnbList/detail_bnbList', { state: { userData: row } })}
                          sx={{
                            boxShadow: 'none',
                            backgroundColor: '#8ecae6',
                            color: '#023047',
                            '&:hover': {
                              backgroundColor: '#8ecae6',
                              boxShadow: 'none',
                            },
                          }}
                          size="small"
                          variant="contained"
                          startIcon={<FaRegEye />}
                        >
                          Detail
                        </Button> */}
                          <Button
                            onClick={() => navigate('/bnbList/update_bnbList', { state: { userData: row } })}
                            sx={{
                              boxShadow: 'none',
                              backgroundColor: '#B5FFD8',
                              color: '#009245',
                              '&:hover': {
                                backgroundColor: '#B5FFD8',
                                boxShadow: 'none',
                              },
                            }}
                            size="small"
                            variant="contained"
                            startIcon={<MdOutlineEdit />}
                          >
                            Edit
                          </Button>
                          <Button
                            onClick={(event) => handleDelete(_id)}
                            sx={{
                              boxShadow: 'none',
                              backgroundColor: '#FFC6C6',
                              color: '#DC2626',
                              '&:hover': {
                                backgroundColor: '#FFC6C6',
                                boxShadow: 'none',
                              },
                            }}
                            size="small"
                            variant="contained"
                            startIcon={<CiTrash />}
                          >
                            Delete
                          </Button>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
                {loading && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7}>
                      <CircularProgress size="20px" />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[100, 200, 300]}
          component="div"
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/*     
        <Link
          
          style={{ textDecoration: 'none' }}
          // to={`/dashboard/user-detail/${encodeURIComponent(JSON.stringify(clickedRow))}`}
          to={`/dashboard/user-detail?data=${encodedData}`}
        > */}
        <MenuItem
          onClick={() => navigate('/contractor/contractor-detail', { state: { clickedRowData } })}
          sx={{ color: 'success.main' }}
        >
          <Iconify icon={'eva:image-outline'} sx={{ mr: 2 }} />
          Detail
        </MenuItem>
        {/* </Link> */}
        <MenuItem>
          <Iconify icon={'eva:edit-outline'} sx={{ mr: 2 }} />
          Block
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
